class LinkResourceList{
	constructor(editDialog) {
		this._activity = null;
		this._layerId = null;

		this.list = new OrderedList();
		this.editDialog = editDialog;

		this.elem = UI.div(null, [
			this.list.container,
			this.addButton = UI.btn('m-3', _("+ Add linked resource"), 
				{'click': this.showSearchDialog.bind(this)}
			)
		]);

		this.resourceSearchText = UI.text();
		onEv(this.resourceSearchText, 'keyup', this.search.bind(this));
		
		this.searchDialog = Dialog.Modal(
			'resource-search', _('Resource search'), LARGE, null,
			this.searchResultContainer = UI.div()
		);
		this.searchDialog.head = UI.div('', this.resourceSearchText);
	}

	showSearchDialog() {
		this.searchResultContainer.innerHTML = '';
		this.searchDialog.open();
		this.resourceSearchText.value = '';
		this.resourceSearchText.focus();
		this.search();
	}
	
	search(ev) {
		if (ev && ev.keyCode === AC.ESCAPE_KEY) return;
		// ajax call for resources. send the resource search text value
		if (!this._activity) return;
		API.fetch(
			`items/linked/${this._activity.id}`,
			{
				text: this.resourceSearchText.value,
				targetLayer: this._layerId
			}
		)
		.then(reply => {
			this.searchResultContainer.innerHTML = '';
			this.linkResourceResults = [];
			if (!reply.items) return;
			this.isLayerOwner = !!reply.userOwnsTarget;
			for (let i = 0, ii = reply.items.length; i < ii; i++) {
				let item = new LinkResource(reply.items[i]);
				this.linkResourceResults.push(item);

				let buttons = [];
				if (item.isLinkable() || item.isShareable())
					buttons.push(UI.priIconBtn('link', 18, {
						'click': this.onResourceSelect.bind(this, i, 0)
					}));
				else buttons.push(UI.priIconBtn('copy', 18, {
					'click': this.onResourceSelect.bind(this, i, 1)
				}));
				this.searchResultContainer.appendChild(UI.listRow([
					UI.img('list-row-graphic', graphicSrc(item.graphicId)),
					UI.icon(ITEM.NAMES[item.type], 18),
					UI.div('flex-1', item.name),
					UI.div('flex-1 text-sm', 'belongs to ' + item.ownerName),
					UI.div('flex-0', buttons)
				]));
			}
		});
	}

	onResourceSelect(index, copyOf) {
		// set the resource id as the link resource for the event
		if (index !== null){
			let item = this.linkResourceResults[index];
			if (copyOf) item.copyOfSelf();
			this.addLink(item);
		}
		this.searchDialog.close(); 
	}
	
	getData(activity, layer) {
		this._activity = activity;
		this._layerId = layer.id;
		this.clearList();
		if (activity.id == 0 && activity.copyOf == 0) {
			this.editDialog.ready();
			return;
		}
		let id = activity.id || activity.copyOf;

		API.fetch(
			`items/linked/${id}`,
		)
		.then (reply => {
			for (let i = 0, ii = reply.items.length; i < ii; i++) {
				let lr = reply.items[i];
				this.list.addItem(new LinkResource(lr, this));
			}
			this.editDialog.ready();
		});
	}
	
	addLink(linkResource) {
		// add the item to the list
		linkResource.setList(this);
		this.list.addItem(linkResource);
	}
	
	clearList() {
		// clear the list in prep for next activity
		this.list.clear();
	}
	
	getSaveData() {
		// iterate through the list and get save data for each.
		this.list.reOrder();
		let values = [];
		if (this.list.reset()) while (this.list.moveNext()) {
			values.push(this.list.item.getSaveData());
		}
		return values;
	}
}